export default __webpack_public_path__ + "static/media/ties.faef4000.webp";